import { useContext } from "react";
import { LangContext } from "../../App";

export type TablePrimaryProps = {
    headers : string[] | JSX.Element[];
    children : JSX.Element | JSX.Element[] | any;
    head? : string;
    note? : string;
    textDirection? : string[];
    headerBgWhite? : boolean;
}

const TablePrimary = ({ children, headerBgWhite = true, headers, head, note, textDirection = ["s", "s", "s", "s"] } : TablePrimaryProps) => {
    const { lang } = useContext(LangContext);

  return (
    <div className="table-wrapper">
    {head ? <h3 className="head">{head}</h3> : ""}
    <table className={`table-primary ${headerBgWhite ? "bg-white" : ""}`}>
        {
        headers.length > 0 ?
        <thead>
            <tr>
                {headers.map((item, index) => (
                    <th key={index} style={{ textAlign : (textDirection[index] === "e" && !lang) ? "end" : "start"}}>{item}</th>
                ))}
            </tr>
        </thead> :
        ""
        }
        <tbody>
            {children}
        </tbody>
    </table>
    {note ? <p className="note">{note}</p> : ""}
    </div>
  )
}

export default TablePrimary